import {
  CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA,
  CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  rightholder: null,
  bookList: null,
  paginateBy: 48, // количество книг в выдаче
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'popular',
  subscriptionId: null,
  bookType: null,
  totalBookCount: null,
};

export default function booksetList(state = initialState, action) {
  switch (action.type) {
    case CATALOG_RIGHTHOLDER_BOOK_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_RIGHTHOLDER_BOOK_LIST_RESET_DATA:
      return initialState;
    default:
      return state;
  }
}
